import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const setMeta = (title, description) => {
  if (title) document.title = title;
  const m = document.querySelector('meta[name="description"]');
  if (m && description) m.setAttribute("content", description);
};

export default function usePageMeta(key) {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    setMeta(t(`meta.${key}.title`), t(`meta.${key}.description`));
    document.documentElement.lang = (i18n.language || "fr").slice(0, 2);
  }, [key, t, i18n.language]);
}
